import React, {createRef} from "react";
import {useOnScreen} from "../../components/useOnScreen";
import { Title, Wrapper } from "../../GlobalStyle";
import { TeamsWrapper } from "./Styled";

const TEAM_LIST = [
  {
    name: "Soh Shuai Quan",
    position: "CEO, SEEDverse",
    image: require('../../images/team-sq.jpg'),
  },
  {
    name: "Nison Chan",
    position: "CMO, SEEDverse",
    image:  require('../../images/team-nison.jpg'),
  },
  {
    name: "Ian Gan",
    position: (
      <>
        Advisor, SEEDverse <br /> CEO, SEED Ventures
      </>
    ),
    image:  require('../../images/team-ian.jpg'),
  },
];

function Teams() {
  const containerRef = createRef();
  const isVisible = useOnScreen(containerRef);

  return (
    <TeamsWrapper id="teams" ref={containerRef}>
      <Wrapper>
        <Title>Our Teams</Title>
        <div className="teams-container">
          {TEAM_LIST.map((team, index) => {
            const { name, position, image } = team;
            return (
              <div className="team-member" key={index}>
                <div className={`img-wrapper ${isVisible ? 'active' : ''}`}>
                  <img src={image} alt={name} />
                </div>
                <strong>{name}</strong>
                <div>{position}</div>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </TeamsWrapper>
  );
}
export default Teams;
